import { Box } from "@mui/material";
import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import "./LogsTable.scss"


function LogsTable() {    
  const [logsData, setLogsData] = React.useState([
    {
      log_creation_time: "11:00PM",
      log_creation_date: "23 Nov, 2022",
      log_activty: "Change SPOC Detail",
      field: "Email Id",
      log_desc: "SP01-Rahul email id changes to rahul@evervent.in",
      type: "Modification",
    },
    {
      log_creation_time: "11:00PM",
      log_creation_date: "23 Nov, 2022",
      log_activty: "Change SPOC Detail",
      field: "Email Id",
      log_desc: "SP01-Rahul email id changes to rahul@evervent.in",
      type: "Modification",
    },
    {
      log_creation_time: "11:00PM",
      log_creation_date: "23 Nov, 2022",
      log_activty: "Change SPOC Detail",
      field: "Email Id",
      log_desc: "SP01-Rahul email id changes to rahul@evervent.in",
      type: "Modification",
    },
    {
      log_creation_time: "11:00PM",
      log_creation_date: "23 Nov, 2022",
      log_activty: "Change SPOC Detail",
      field: "Email Id",
      log_desc: "SP01-Rahul email id changes to rahul@evervent.in",
      type: "Modification",
    },    
]);
    return(        
        <>
             <Box>
                    <Grid xs={12} className="px-0">
                      <div className="tableview">
                        <div className="tableinner">
                          <ul className="tableHeader">
                            <li>
                              Creation Time
                              <button className="sorting-btn"></button>
                            </li>
                            <li>
                              Creation Date
                              <button className="sorting-btn"></button>
                            </li>
                            <li>
                              Activity
                              <button className="sorting-btn"></button>
                            </li>
                            <li>
                              Field
                              <button className="sorting-btn mr-0"></button>
                            </li>
                            <li>
                              Description
                              <button className="sorting-btn mr-0"></button>
                            </li>
                            <li>
                              Type
                              <button className="sorting-btn mr-0"></button>
                            </li>
                          </ul>
                          {logsData.map((data, index) => (
                            <ul className="tableData">
                              <li>{data.log_creation_time}</li>
                              <li>{data.log_creation_date}</li>
                              <li>{data.log_activty}</li>
                              <li>{data.field}</li>
                              <li>{data.log_desc}</li>
                              <li>{data.type}</li>
                            </ul>
                          ))}
                        </div>
                      </div>
                    </Grid>
                  </Box>
        </>
    )
}
export default LogsTable;
